import React from "react";
import ModalCreateAdmin from "./ModalCreateAdmin";
import Button from "../../atoms/Button";
import Modal from "../../molecules/Modal";
import useModal from "../../../hooks/useModal";
import { FaUserPlus } from "react-icons/fa6";

const CreateAdmin = ({ refetch }) => {
    const { open, close, isOpen } = useModal();

    return(
        <div>
            <Button text={<FaUserPlus size={22} />} bgColor="green" onClick={open} width="w-10" />
            {isOpen && 
                <Modal title="Crear administrador" onClose={close}>
                    <ModalCreateAdmin onClose={close} refetch={refetch}/>
                </Modal>
            }
        </div>
    );
};

export default CreateAdmin;